




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";

class HeaderItem {
  weekDay: string;
  day: number;
  get dayText(): string {
    const str = "00" + this.day;
    return str.substring(str.length - 2);
  }
  constructor(weekDay: string, day?: number) {
    this.weekDay = weekDay;
    this.day = day;
  }
}
class BodyItem {
  date: Date;
  active: boolean;
  get text(): string {
    const str = "00" + this.date.getDate();
    return str.substring(str.length - 2);
  }
  constructor(date: Date, active = true) {
    this.date = date;
    this.active = active;
  }
}
const month = "month";
const week = "week";

@Component({
  name: "ui-event-calendar"
})
export default class UiEventCalendarComponent extends Vue {
  @Prop({
    default: week,
    required: true,
    validator: (x: string) => {
      return x == week || x == month;
    }
  })
  view: string;
  @Prop({ required: true, type: Date }) start: Date;
  @Prop({ required: true, type: Date }) end: Date;
  daysOfWeek = [
    new HeaderItem("Пн"),
    new HeaderItem("Вт"),
    new HeaderItem("Ср"),
    new HeaderItem("Чт"),
    new HeaderItem("Пт"),
    new HeaderItem("Сб"),
    new HeaderItem("Вс")
  ];
  get items(): Date {
    return new Date();
  }
  get headers(): HeaderItem[] {
    if (this.view == month) {
      return this.daysOfWeek;
    }
    return this.getWeekViewHeaders();
  }
  bodyItems = new Array<BodyItem>();
  getWeekViewHeaders(): HeaderItem[] {
    return this.bodyItems.map(bi => {
      var wd = this.daysOfWeek[this.getWeekDay(bi.date)];
      wd.day = bi.date.getDate();
      return wd;
    });
    //return this.daysOfWeek;
  }
  created() {
    this.recalcBodyItems();
  }
  addDays(date: Date, days: number): Date {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  getWeekDay(date: Date): number {
    // день недели 0-6 (0 - пнд)
    return (date.getDay() + 6) % 7;
  }
  @Watch("start")
  @Watch("end")
  recalcBodyItems() {
    this.bodyItems = new Array<BodyItem>();
    let date = this.start;
    if (this.view == month) {
      var weekStart = this.getWeekDay(this.start); // 0-6
      for (let i = 0; i < weekStart; i++) {
        //debugger;
        let prevDate = this.addDays(this.start, i - weekStart);
        this.bodyItems.push(new BodyItem(prevDate, false));
      }
    }
    while (date <= this.end) {
      this.bodyItems.push(new BodyItem(date));
      date = this.addDays(date, 1);
    }

    if (this.view == month) {
      var weekStart = this.getWeekDay(this.end); // 0-6
      for (let i = weekStart, j = 1; i < 6; i++, j++) {
        let nextDate = this.addDays(this.end, j);
        this.bodyItems.push(new BodyItem(nextDate, false));
      }
    }
  }
  get bodyItemStyle(): Object {
    return this.view == week ? { gridRow: 2 } : {};
  }
  get innerStyle(): Object {
    return {
      gridTemplateColumns: this.columnTemplate
    };
  }
  get columnTemplate(): string {
    if (this.view == month) {
      return "repeat(7, 1fr)";
    }
    return "repeat( auto-fit, minmax(0, 1fr))";
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-event-calendar/src/ui-event-calendar.vue